// extracted by mini-css-extract-plugin
module.exports = {"container":"dashboard_container__17A8W","notFoundError":"dashboard_notFoundError__2b-qO"};